import util from '@bmp-vue/core/api/util'

const controller = 'ControleRelatorioParceiro'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']), {
  GetAllRelatorioParceiros: function (dto) {
    return util.Axios.GetAll(controller , dto)
  },
  ReenvioRelatorioParceiro: function (dto) {
    return util.Axios.Post(controller + '/Reenvio', dto); 
  },
  ReprocessarRelatorioParceiro: function (dto) {
    return util.Axios.Post(controller + '/Reprocessar', dto); 
  },
  RetornoJsonRelatorioParceiro: async function(nomeArquivo, codigoParceiro) {
    const data = await util.Axios.GetAll(
      controller + `/${codigoParceiro}/Retorno/${nomeArquivo}`
    );
    return JSON.stringify(data, null, 4);
  },
})
